export default __webpack_public_path__ + "static/media/010-lotion.50fc5207.svg";